import { Divider, Flex, Spacer } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useContextSelector } from 'use-context-selector';
import { LetterGutter } from '../LetterGutter';
import { LetterPicker } from '../LetterPicker';
import { NewSyncBadge } from './SyncBadge';
import { ActionButtons, BackToWritingDeskButton } from './ActionButtons';
import { DeleteLetterModal, SendLetterModal } from './ActionModals';
import { Editor } from './Editor';
import EditorContainer from './EditorContainer';
import EditorContext from './EditorContext';
import { EditorContextProvider } from './EditorContextProvider';
import { EditorGrid } from './EditorGrid';
import LetterTitle from './LetterTitle';
import { SideCar } from './SideCar';
import WritingTo from './WritingTo';

const DividerWhenSideCar = () => {
  const { letterId } = useContextSelector(EditorContext, (v) => v.sideCar);
  return letterId ? <Divider mt={8} /> : <></>;
};

export const EditorRoot = () => {
  const { letterId } = useParams<{ letterId: string }>() as { letterId: string };

  return (
    <EditorContextProvider id={letterId}>
      <EditorContainer>
        <Flex direction={'row'} justify="space-between">
          <BackToWritingDeskButton />
          <LetterPicker />
        </Flex>

        <Spacer h={2} />

        <EditorGrid>
          <LetterGutter>
            <WritingTo />
            <LetterTitle />
            <Editor />
            <DividerWhenSideCar />
            <NewSyncBadge />
          </LetterGutter>
          <SideCar />
        </EditorGrid>

        <Spacer h={2} />

        <ActionButtons />

        <DeleteLetterModal />
        <SendLetterModal />
      </EditorContainer>
    </EditorContextProvider>
  );
};
